import { render } from "./ServiceIndividual.vue?vue&type=template&id=1e8dbd52&scoped=true"
import script from "./ServiceIndividual.vue?vue&type=script&lang=js"
export * from "./ServiceIndividual.vue?vue&type=script&lang=js"

import "./ServiceIndividual.vue?vue&type=style&index=0&id=1e8dbd52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e8dbd52"]])

export default __exports__